import type { TFunction } from '../i18n';

/** The title the server gives a conversation until it names it after the first question. */
export const UNTITLED = 'New conversation';

/** A conversation's title as shown, with the placeholder title in the user's language. */
export function conversationTitle(title: string, t: TFunction): string {
  return title === UNTITLED ? t('newConversation') : title;
}
